import { render, staticRenderFns } from "./staticisp-orders.vue?vue&type=template&id=3d1a38ba&scoped=true"
import script from "./staticisp-orders.vue?vue&type=script&lang=js"
export * from "./staticisp-orders.vue?vue&type=script&lang=js"
import style0 from "./staticisp-orders.vue?vue&type=style&index=0&id=3d1a38ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a38ba",
  null
  
)

export default component.exports